import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['container', 'card', 'placeholder', 'template']
  static values = { maxCards: { type: Number, default: 3 } }

  connect () {
    this.#updatePlaceholderVisibility()
  }

  addCard () {
    const index = this.cardTargets.length
    const clone = this.templateTarget.content.cloneNode(true)

    clone.querySelectorAll('[name]').forEach(el => {
      el.name = el.name.replaceAll('__INDEX__', index)
    })

    clone.querySelectorAll('[id]').forEach(el => {
      el.id = el.id.replaceAll('__INDEX__', index)
    })

    this.containerTarget.insertBefore(clone, this.placeholderTarget)
    this.#updatePlaceholderVisibility()
  }

  removeCard (event) {
    const card = event.currentTarget.closest('[data-scenario-cards-target~="card"]')
    card.remove()
    this.#reindexCards()
    this.#updatePlaceholderVisibility()
  }

  #reindexCards () {
    this.cardTargets.forEach((card, index) => {
      card.querySelectorAll('[name]').forEach(el => {
        el.name = el.name.replace(/\[scenarios\]\[\d+\]/, `[scenarios][${index}]`)
      })

      card.querySelectorAll('[id]').forEach(el => {
        el.id = el.id.replace(/(toggle|gesture)_\d+_/, `$1_${index}_`)
      })
    })
  }

  #updatePlaceholderVisibility () {
    if (!this.hasPlaceholderTarget) return
    this.placeholderTarget.hidden = this.cardTargets.length >= this.maxCardsValue
  }
}
